import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';

@Component({
  selector: 'threat-assessment-summary-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './threat-assessment-summary-signature.component.html',
  styleUrl: './threat-assessment-summary-signature.component.css'
})
export class ThreatAssessmentSummarySignatureComponent implements OnInit, OnChanges {

  @Input() threatAssessmentSummaryData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  summarySignatureForm: FormGroup = new FormGroup([]);
      
  currentDate = new Date();
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private route: ActivatedRoute,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();
    
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['threatAssessmentSummaryData'] && this.threatAssessmentSummaryData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.summarySignatureForm = new FormGroup({
      user_signature_name: new FormControl(this.threatAssessmentSummaryData?.user_signature_name || '', Validators.required),
    });
  }

  saveSummarySignature(): void {
    if (this.summarySignatureForm.valid) {
        this.onSaveSection2.emit(this.summarySignatureForm.value);
    }
  }


}
